import { render } from "./ActivationManagement.vue?vue&type=template&id=3e025828&scoped=true&ts=true"
import script from "./ActivationManagement.vue?vue&type=script&lang=ts"
export * from "./ActivationManagement.vue?vue&type=script&lang=ts"

import "./ActivationManagement.vue?vue&type=style&index=0&id=3e025828&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e025828"]])

export default __exports__